import React, {  useEffect, useRef } from "react";
import {  Loader } from "../components";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../assets/nutrackx.png";
import { CloudDownloadOutlined } from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import LateAttTable from "../components/EmployeesTable/lateAttTable";
import { fetchingLateAttStart, fetchingLateAttSuccess } from "../redux/LateAttSlice";
import { useSearchParams } from "react-router-dom";
import { postRequest } from "../utils/APICall";
import { reduxFromDate, reduxToDate } from "../redux/setDates";
const LateAttReport = ({name}) => {
  const tableHead = `pt-2 pb-4 border-b text-center text-gray-800 font-bold text-[16px]`;
  const tableBody = `pt-2 pb-4 border-b font-semibold text-center text-[16px]`;
  const pdfRef = useRef();
  const headerRef = useRef();
  // 
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  useEffect(() => {
  const fetchData = async () => {
    dispatch(fetchingLateAttStart());

    const fromDate = searchParams.get("fromDate");
    const toDate = searchParams.get("toDate");
    const department = searchParams.get("department");
    const empid = searchParams.get("employee");
    // console.log(department)
    dispatch(reduxToDate(toDate));
    dispatch(reduxFromDate(fromDate));

    let route, obj;

    if (empid && empid !== "All") {
      route = "LateAttReport";
      obj = { empid: Number(empid), todate: toDate, fromdate: fromDate };
    } else if (department === "All") {
      route = "LateAttReport";
      obj = { todate: toDate, fromdate: fromDate };
    } else {
      route = `LateAttReport?departmentcode=${Number(department)}`;
      obj = { todate: toDate, fromdate: fromDate };
    }

    try {
      const response = await postRequest(route, obj);
      dispatch(fetchingLateAttSuccess(response?.data));
    } catch (err) {
      console.error("Error fetching late attendance:", err);
    }
  };

  fetchData();
}, [searchParams, dispatch]);

  // 
  const { lateAttData, isFetching } = useSelector(
    (state) => state.lateAtt
  );
  // console.log("lateAtt",lateAttData)

  const handleDownload = async () => {
    await downloadPDF();
  };
  const groupEmployeeAttendance = (data) => {
    // console.log("data->>>>",data)
    const grouped = {};

    data?.forEach((record) => {
      const {
        FK_EMPID,
        NAME,
        ENTRYTIME,
        LEAVEINGTIME,
        ATTENDANCE_STATUS,
        REMARKS,
        DEPTGRACETIME,
        DEPTITLE,
      } = record;

      const date = ENTRYTIME?.split(" ")[0];
      const entryTime = ENTRYTIME?.split(" ").slice(1).join(" ");
      const leavingTime = LEAVEINGTIME?.split(" ").slice(1).join(" ");

      if (!grouped[FK_EMPID]) {
        grouped[FK_EMPID] = {
          NAME,
          DEPTITLE,
          DEPTGRACETIME,
          attendanceData: [],
        };
      }

      grouped[FK_EMPID].attendanceData.push({
        date,
        entryTime,
        leavingTime,
        remark: REMARKS ?? "present",
        late: ATTENDANCE_STATUS,
      });
    });
    return Object.values(grouped);
  };

  const employeeAttendanceData = groupEmployeeAttendance(lateAttData);
  // console.log("employeeAttendanceData",employeeAttendanceData)

  // Count total lates across all employees
  let totalLateCount = 0;
  employeeAttendanceData?.forEach((employee) => {
    employee?.attendanceData?.forEach((attendance) => {
      if (attendance.late === "Late") {
        totalLateCount++;
      }
    });
  });

  const calculatedAbsents = Math.floor(totalLateCount / 3);

  // console.log(singleEmployeeAttendance[0])
  const downloadPDF = async () => {
    const input = pdfRef.current;
    const headerValues = headerRef.current;

    const headerCanvas = await html2canvas(headerValues, { scale: 1 }); // Reduce scale
    const headerData = headerCanvas.toDataURL("image/jpeg", 0.6); // Compress header image with JPEG and quality 0.6

    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const pageHeight = 297;
    const headerHeight = 20;
    const footerHeight = 16;
    const contentHeight = pageHeight - headerHeight - footerHeight;

    const rows = Array.from(input.querySelectorAll("tr"));
    const totalRows = rows.length;
    const rowsPerPage = 19;
    const totalPages = Math.ceil(totalRows / rowsPerPage);

    const applyHeaderStyle = (row) => {
      row.style.height = "40px";
      row.style.fontSize = "24px";
      row.style.backgroundColor = "#CCCCCC";
      row.style.boxSizing = "border-box";
    };
    applyHeaderStyle(rows[0]);
    const secondRowClone = rows[0].cloneNode(true);
    applyHeaderStyle(secondRowClone);

    for (let i = 0; i < totalPages; i++) {
      const startRow = i * rowsPerPage;
      const endRow = Math.min(startRow + rowsPerPage, totalRows);
      const tableChunk = document.createElement("table");
      tableChunk.style.width = input.offsetWidth + "px";
      if (i > 0) {
        tableChunk.appendChild(secondRowClone.cloneNode(true));
      }

      rows.slice(startRow, endRow).forEach((row, rowIndex) => {
        // if (i > 0 && rowIndex === 0) return;
        const rowClone = row.cloneNode(true);
        tableChunk.appendChild(rowClone);
      });

      document.body.appendChild(tableChunk);
      const chunkCanvas = await html2canvas(tableChunk, { scale: 1 });
      document.body.removeChild(tableChunk);

      const imgData = chunkCanvas.toDataURL("image/jpeg", 0.6);

      pdf.addImage(headerData, "PNG", 0, 0, imgWidth, headerHeight);
      const imgHeight = (chunkCanvas.height * imgWidth) / chunkCanvas.width;
      const contentY = headerHeight;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.setFontSize(8);
      const pageNumText = `Page ${i + 1} of ${totalPages}`;
      const pageNumTextWidth = pdf.getTextWidth(pageNumText);
      pdf.text(pageNumText, imgWidth - pageNumTextWidth - 4, pageHeight - 5);
      pdf.text(
        `Printed On: ${new Date().toLocaleDateString(
          "en-GB"
        )} ${new Date().toLocaleTimeString()}`,
        10,
        pageHeight - 5
      );

      if (i < totalPages - 1) {
        pdf.addPage();
      }
    }

    // Save the PDF
    // pdf.save(
    //   `${singleEmployeeAttendance.length !== 1 ? singleEmployeeAttendance[0].firstname : "All Employee"}.pdf`
    // );
    pdf.save(`${name == "All" ? "All" : name}.pdf`)
  };
  const { toDate, fromDate } = useSelector((state) => state.setDates);
  
  return (
    <>
      <div className=" -z-10">
        <div className="h-full">
          <div className="flex w-full  items-center ">
            <h1 className="flex  w-full justify-center  text-lg items-center  sm:text-xl lg:text-2xl font-bold text-start md:py-2 md:mb-0">
              Late Attendence Report
            </h1>
            <button className="flex justify-around  items-center mr-5">
              <CloudDownloadOutlined
                onClick={handleDownload}
                className="text-[26px]  md:-mt-0 text-center md:text-[30px] "
              />
            </button>
          </div>
         
        </div>
        {isFetching ? <Loader /> : <LateAttTable empAttData={employeeAttendanceData} totalLateCount={totalLateCount}  calculatedAbsents={calculatedAbsents}/>}
       
        {lateAttData && (
          <span
            style={{
              position: "fixed",
              left: "-9999px",
              width: "210mm",
            }}
          >
            <div
              ref={headerRef}
              className="flex items-center justify-between w-full border-b-2 border-gray-600"
            >
              <div className="w-1/6">
                <img src={Logo} alt="" height={90} width={200} />
              </div>
              <h1 className="w-3/6 text-[22px] font-semibold text-center mb-5">
                Late Attendance Report
              </h1>
              <div className="w-2/6  text-start mb-2 relative">
                <span className="text-[12px] font-semibold absolute right-5 top-0">
                  ({fromDate}&nbsp;-&nbsp;{toDate})
                </span>
              </div>
            </div>
            <div ref={pdfRef} className="">
              <div className="w-full">
                <table className="w-[210mm] border border-gray-400 pt-5">
                  <thead className="bg-gray-300 w-full h-full">
                    <tr className="text-center w-full">
                      <th className={`${tableHead} w-5/12`}>Date</th>
                      <th className={`${tableHead} w-2/12`}>Entry Time</th>
                      <th className={`${tableHead} w-2/12`}>Leaving Time</th>
                      <th className={`${tableHead} w-1/12`}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                             {employeeAttendanceData?.map((employee, empIndex) => (
                               <React.Fragment key={empIndex}>
                                 <tr className=" bg-gray-300 text-gray-900 text-center">
                                   <td colSpan={4} className="py-2 font-bold text-lg capitalize">
                                     {employee.NAME} ({employee?.DEPTITLE}) {employee?.DEPTGRACETIME}
                                   </td>
                                 </tr>
                 
                                 {employee?.attendanceData?.map((attendance, index) => (
                                   <tr
                                     key={index}
                                     className={`${attendance.late === "Late" ? "bg-yellow-50" : ""
                                       }`}
                                   >
                                     <td className={tableBody}>
                                       {attendance.date}
                                      
                                     </td>
                                     <td className={tableBody}>{attendance.entryTime || "-"}</td>
                                     <td className={tableBody}>
                                       {attendance.leavingTime || "-"}
                                     </td>
                                     <td className={tableBody}>{attendance.late || "-"}</td>
                 
                                   </tr>
                                 ))}
                                 <tr className="bg-gray-300 text-gray-900 text-center">
                                     <td colSpan={2} className="py-2 font-bold  capitalize">
                                       Total Late Entries: {totalLateCount} &nbsp; | &nbsp;As per Policy 3 Lates = 1 Absent 
                                     </td>
                                     <td  colSpan={2} className="bg-red-300 font-semibold">After Calculated Total Absent = {calculatedAbsents}</td>
                                 </tr>
                 
                               </React.Fragment>
                             ))}
                           </tbody>
                </table>
              </div>
            </div>
          </span>
        )}
      </div>
    </>
  );
};

export default LateAttReport;
